import { render, staticRenderFns } from "./contentCard.vue?vue&type=template&id=ea1cd956&scoped=true&"
import script from "./contentCard.vue?vue&type=script&lang=js&"
export * from "./contentCard.vue?vue&type=script&lang=js&"
import style0 from "./contentCard.vue?vue&type=style&index=0&id=ea1cd956&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1cd956",
  null
  
)

export default component.exports